// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"419":"334673f4","476":"5385bbf2","566":"e845458d","956":"3d51ab52"}[chunkId] + ".chunk.css";
};